import styled from 'styled-components'

export const Content = styled.div<{ left?: boolean; right?: boolean; stretch?: boolean }>`
  display: flex;
  justify-content: ${({ left, right, stretch }) =>
    left ? 'flex-start' : right ? 'flex-end' : stretch ? 'stretch' : 'center'};
`
